export const isSalesAnalysisProgressPending = (progress: unknown) =>
  typeof progress === 'number' && progress >= 0 && progress < 100;
